import { createRequestModel, createRequestFetcher } from 'src/dal/modules';
import { apiEndpoints } from 'src/dal/config/apiEndpoints';
import { RequestMethod } from 'src/dal/config/requestMethod';

import type { TSendSmsRequestPayload, TSignAgreementRequestPayload } from './typing';

const sendSms = createRequestModel({
  method: RequestMethod.POST,
  path: apiEndpoints.sendSms,
});

export const sendSmsFetcher = createRequestFetcher<void, TSendSmsRequestPayload>(sendSms);

const signAgreement = createRequestModel({
  method: RequestMethod.POST,
  path: apiEndpoints.signAgreement,
});

export const signAgreementFetcher = createRequestFetcher<void, TSignAgreementRequestPayload>(signAgreement);
